export default __webpack_public_path__ + "static/kontakt_grafika-c53ba200b68134d6512b5930c7282f6c.svg";